import React from 'react';
import styled from 'styled-components';

import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';

const Frame = styled.div`
  display: inline-flex;
  padding: var(--space-md);
  border-radius: var(--radius-md, 8px);
  /* White background and padding form the quiet zone a scanner needs. */
  background: #ffffff;
  border: 1px solid var(--border, #e5e7eb);
`;

const OffscreenCanvas = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
`;

export interface QrCodeSvgProps {
  value: string;
  size?: number;
  /** Rendered SVG, for vector export. */
  svgRef: React.RefObject<SVGSVGElement>;
  /** Hidden canvas of the same code, the only way to rasterise to PNG. */
  canvasRef: React.RefObject<HTMLCanvasElement>;
}

export const QrCodeSvg: React.FC<QrCodeSvgProps> = ({
  value,
  size = 200,
  svgRef,
  canvasRef,
}) => (
  <>
    <Frame>
      <QRCodeSVG
        ref={svgRef}
        value={value}
        size={size}
        // Medium correction tolerates print smudging without inflating the code.
        level="M"
        marginSize={2}
        title="Código QR del paquete compartido"
      />
    </Frame>
    <OffscreenCanvas aria-hidden="true">
      <QRCodeCanvas
        ref={canvasRef}
        value={value}
        size={size * 2}
        level="M"
        marginSize={2}
      />
    </OffscreenCanvas>
  </>
);
